import {api, API_URL} from './client';
import { FileEntity } from "../types/entities/file.entity.ts";

const basePath = '/file-manager';

export const fileExplorerService = {
    getAll: async (path: string = '/') => {
        const url = `${basePath}?path=${path}`;
        
        const response = await api.get(url);
        return response.data.data;
    },
    preview: async (file: FileEntity) => {
        const url = `${basePath}/preview`;

        const response = await api.post(url, {
            path: file.path
        });
        return response.data.data?.link;
    },
    delete: async(files: FileEntity[]) => {
        const url = `${basePath}/delete`;

        const paths = files.map(file => file.path);

        const response = await api.delete(url, {
            data: { paths }
        });

        return response.data.data;
    },
    addFolder: async(path: string) => {
        const url = `${basePath}/create-folder`;

        const response = await api.post(url, {
            folder_name: path
        });

        return response.data.data;
    },
    paste: async (params: { files: FileEntity[]; newFolder: FileEntity; action: string }) => {
        const url = `${basePath}/move`;

        const { files, newFolder, action } = params;
        const paths = files.map((file) => ({
            old_path: file.path,
            new_path: `${newFolder.path}/${file.name}`
        }));

        const response = await api.put(url, {
            paths,
            action
        });

        return response.data.data;
    },
    rename: async (params: { file: FileEntity; newName: string }) => {
        const url = `${basePath}/move`;

        const { file, newName } = params;

        const lastSlashIndex = file.path.lastIndexOf('/');
        const directoryPath = lastSlashIndex > 0 ? file.path.substring(0, lastSlashIndex) : '/';

        const paths = [
            {
                old_path: `${file.path}`,
                new_path: `${directoryPath}/${newName}`,
            }
        ];

        const response = await api.put(url, {
            paths,
            action: 'move',
        });

        return response.data.data;
    },
    getUploadUrl: () => {
        return `${API_URL}${basePath}/upload`;
    }
};
